
import axios from "axios";
import { NEW_API_URL } from "../config/api";
import { TIMESERIES_FIRE_RISK_DAY_DURATION } from "../constants/app";

export const fetchActiveFires = () => {
	return new Promise((resolve, reject) => {
		axios.get(`${NEW_API_URL}firedata/ca/active.json`)
			.then((response) => {
				resolve(response.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const fetchFireRiskForPoint = ({ date, lat, lng }) => {
	return new Promise((resolve, reject) => {
		axios.get(`${NEW_API_URL}firerisk/${date}/point/${lng},${lat}`)
		.then((response) => {
			resolve(response.data.values[0]);
		})
		.catch((err) => {
			reject(err);
		});
	});
};

export const fetchTimeseriesFireRisk = ({ date, lat, lng }) => {
	return new Promise((resolve, reject) => {
        axios.get(`${NEW_API_URL}firerisk/${date}/timeseries/${TIMESERIES_FIRE_RISK_DAY_DURATION}day/${lng},${lat}`)
		.then((response) => {
			resolve(response.data);
		})
		.catch((err) => {
			reject(err);
		});
	});
};
